import LoadingIndicator from "../CommonComponent/LoadingIndicator";

function PageTable(props) {
    return (
        <div className="table-grow-container">
            <div className="table-container">
                {props.tableData}
                {props.isTableLoading && <LoadingIndicator size="large" message="Fetching..." />}
            </div>
        </div>
    );
}

export default PageTable;